import unionAlcoyana from './union-alcoyana.svg';
import segurosBilbao from './seguros-bilbao.svg';
import reale from './reale.svg';
import plusUltra from './plus-ultra.svg';
import mgs from './mgs.svg';
import logo from './logo.svg';
import logoWhite from './logo-white.svg';
import helvetia from './helvetia.svg';
import gesSeguros from './ges-seguros.svg';
import fiatcSeguros from './fiatc.svg';
import catalanaOccidente from './catalana-occidente.svg';
import caserSeguros from './caser.svg';
import cars from './cars.svg';
import cars2 from './cars-2.svg';

export const images = {
  cars,
  logoWhite,
  logo,
  // logos
  reale,
  gesSeguros,
  mgs,
  plusUltra,
  helvetia,
  catalanaOccidente,
  segurosBilbao,
  unionAlcoyana,
  caserSeguros,
  fiatcSeguros,
  cars2,
};

export const logoChat = {
  '00000016': logo,
  '00000001': segurosBilbao,
  '00000002': catalanaOccidente,
  '00000006': gesSeguros,
  '00000007': unionAlcoyana,
  '00000010': mgs,
  '00000011': helvetia,
  '00000020': plusUltra,
  '00000025': reale,
  '00000045': fiatcSeguros,
  '00000060': caserSeguros,
};
